import moment from 'moment';
import { put, call, select, takeLatest } from 'redux-saga/effects';

import * as $auth from 'modules/auth';
import * as api from '../api';
import * as actions from '../actions';

const getRandom = (min, max) => {
  return Math.floor(Math.random() * max) + min;
};

const getTestReport = (fromDate, toDate) => {
  const report = {
    Count: [],
    TotalPrice: [],
    TotalCommission: [],
  };

  const diff = moment(toDate).diff(moment(fromDate), 'days');
  for (let i = 0; i < diff; i++) {
    const currentDate = moment(fromDate).add(i, 'days');
    const currentDateKey = moment(currentDate).format('DD-MM-YYYY');

    const countValue = getRandom(0, 20);

    report.Count.push({
      Key: currentDateKey,
      Value: countValue,
    });
    report.TotalPrice.push({
      Key: currentDateKey,
      Value: countValue * 39,
    });
    report.TotalCommission.push({
      Key: currentDateKey,
      Value: countValue * 39 * 0.1,
    });
  }

  return report;
};

const fetchSalesReport = function* ({ payload }) {
  const { fromDate, toDate } = payload;
  const token = yield select($auth.getToken);
  const publisherId = yield select($auth.getSelectedPublisherId);
  const report = yield call(api.fetchSalesReport, fromDate, toDate, { token, publisherId });
  yield put(actions.fetchSalesReportDone(report));
};

export const fetchSalesReportSaga = function* () {
  yield takeLatest(actions.fetchSalesReport, fetchSalesReport);
};
